import React from 'react';

export const assignedNames = (asset, field, directory = []) => {
  const lookup = new Map(directory.map(person => [String(person.id), person.name || person.email]));
  (asset.assigned_users || []).forEach(person => lookup.set(String(person.id), person.name));
  const ids = Array.isArray(asset[field]) ? [...new Set(asset[field].map(String))] : [];
  return ids.map(id => lookup.get(id) || 'Usuario no disponible');
};

export const AssetAssignmentCell = ({ asset, funcion, directory }) => {
  const field = funcion === 'gestor' ? 'gestores' : 'inversores';
  const names = assignedNames(asset, field, directory);
  return (
    <span data-testid={`chip-${funcion}-${asset.id}`}
      title={names.length ? names.join(', ') : `Sin ${field}`}
      className={`inline-block align-middle text-xs px-2 py-1 rounded border truncate max-w-[140px] text-left ${names.length
        ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
        : 'bg-slate-50 text-slate-400 border-dashed border-slate-300'}`}>
      {names.length ? names.join(', ') : '—'}
    </span>
  );
};